export type AppName = 'planning' | 'crm'

export type NavigationTab = { app: AppName, link: string, text: string }

export const navigationTabs: NavigationTab[] = [
  {
    app: 'planning',
    link: '/',
    text: 'Planning & Werkbonnen',
  },
  {
    app: 'crm',
    link: '/',
    text: 'Relaties & Projecten',
  },
  {
    app: 'crm',
    link: '/facturatie',
    text: 'Facturatie Dashboard',
  },
]
